const BAYER_CLIENT_ID = '773a7670-64ca-4869-be37-9c75ad240feb'
export const IS_BAYER =
  import.meta.env.VITE_MSAL_CLIENT_ID === BAYER_CLIENT_ID ||
  window.ENV.MSAL_CLIENT_ID === BAYER_CLIENT_ID ||
  (window.ENV.API_MONOLITH_BASE_URL && window.ENV.API_MONOLITH_BASE_URL.includes('bayer')) ||
  (window.ENV.API_MONOLITH_BASE_URL && window.ENV.API_MONOLITH_BASE_URL.includes('azure.cnb')) ||
  window.origin.includes('azure.cnb')

export const IS_BASF =
  (import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL && import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL.includes('basf')) ||
  (window.ENV.API_MONOLITH_BASE_URL && window.ENV.API_MONOLITH_BASE_URL.includes('basf'))

export const IS_SAIFTY_CLOUD =
  import.meta.env.VITE_AUTH0_DOMAIN?.includes('saifty.cloud') || window.ENV.AUTH0_DOMAIN?.includes('saifty.cloud')

export const IS_BYK =
  (import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL && import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL.includes('byk')) ||
  (window.ENV.API_MONOLITH_BASE_URL && window.ENV.API_MONOLITH_BASE_URL.includes('byk'))

export const IS_HERAEUS =
  (import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL &&
    import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL.includes('heraeus')) ||
  (window.ENV.API_MONOLITH_BASE_URL && window.ENV.API_MONOLITH_BASE_URL.includes('heraeus'))

export const IS_LANXESS =
  (import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL && import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL.includes('lnx')) ||
  (window.ENV.API_MONOLITH_BASE_URL && window.ENV.API_MONOLITH_BASE_URL.includes('lnx')) ||
  (import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL &&
    import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL.includes('lanxess')) ||
  (window.ENV.API_MONOLITH_BASE_URL && window.ENV.API_MONOLITH_BASE_URL.includes('lanxess'))

export const IS_HENKEL =
  (import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL && import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL.includes('henkel')) ||
  (window.ENV.API_MONOLITH_BASE_URL && window.ENV.API_MONOLITH_BASE_URL.includes('henkel'))

const commonRestrictedRoutes = ['query-builder', 'query-builder-id', 'ai-chat']

export function restrictedRoutesByCustomer() {
  let routesToRestrict: string[] = []

  // Add routes based on environment variables
  if (!window.ENV.AI_CHAT_ENABLED) {
    routesToRestrict.push('ai-chat')
  }
  if (!window.ENV.QUERY_BUILDER_ENABLED) {
    routesToRestrict.push('query-builder', 'query-builder-id')
  }
  if (!window.ENV.ASSESSMENTS_PAGE_ENABLED) {
    routesToRestrict.push('assessment')
  }
  if (!window.ENV.REQUESTS_PAGE_ENABLED) {
    routesToRestrict.push('requests', 'requests-new', 'requests-id')
  }
  if (!window.ENV.DATA_SPACE_ENABLED) {
    routesToRestrict.push('mappings', 'mappings-id')
  }
  if (!(import.meta.env.VITE_API_SAP_SYNC_CONFIG_BASE_URL || window.ENV.API_SAP_SYNC_CONFIG_BASE_URL)) {
    routesToRestrict.push('sync-configuration')
  }

  // Add customer-specific restrictions
  if (IS_BASF) {
    routesToRestrict = [...new Set([...routesToRestrict, ...commonRestrictedRoutes])]
  } else if (IS_SAIFTY_CLOUD) {
    routesToRestrict = [...new Set([...routesToRestrict, ...commonRestrictedRoutes])]
  } else if (IS_LANXESS) {
    routesToRestrict = [...new Set([...routesToRestrict, ...commonRestrictedRoutes])]
  }

  return routesToRestrict
}

export const BASF_COATINGS_BUSINESS_UNIT_ZCQ_100 = 'ZCQ-100'
export const BASF_COATINGS_BUSINESS_UNIT_ZCQ_300 = 'ZCQ-300'

export const BASF_COATINGS_BUSINESS_UNITS = [BASF_COATINGS_BUSINESS_UNIT_ZCQ_100, BASF_COATINGS_BUSINESS_UNIT_ZCQ_300]
